export const Links = {
   studio: 'https://premast.com/studio',
   studioRequest: 'https://premast.com/studio/request',
   brands: 'https://app.premast.com/brands',
};
